import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const logUSers = lazy(() => import('../../container/crud/userslogouts/Index'));



const PagesRoute = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}`} component={logUSers} />
 
    </Switch>
  );
};

export default PagesRoute;
